import { useDataChange } from 'Simple/Data.js'

export function useOnFilterClickAll(props) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.ledger.receivables.filter_by',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change([])
  }
}
